import type { StateStore } from '@/types';
import type { InferType } from 'yup';
import type {
	companySizeAndNatureModel,
	estimatedBudgetModel,
	serviceEstimatesModel,
	servicesToProvideModel,
	whoWillRideModel,
} from './onboarding.model';

export enum OnboardingStepStatus {
	PENDING = 'pending',
	COMPLETED = 'completed',
}

export enum EstimateType {
	RIDES = 'Rides',
	MEALS = 'Meals',
	DELIVERY = 'Delivery',
}

export enum BillingMethod {
	TRIP = 'Trip',
	MONTHLY = 'Monthly',
}

export type CompanySizeAndNatureFields = InferType<typeof companySizeAndNatureModel>;
export type ServicesToProvideFields = InferType<typeof servicesToProvideModel>;
export type WhoWillRideFields = InferType<typeof whoWillRideModel>;
export type ServiceEstimatesFields = InferType<typeof serviceEstimatesModel>;
export type BudgetEstimatesFields = InferType<typeof estimatedBudgetModel>;

export enum RidePurpose {
	BusinessTravel = 1,
	OfficeCommute = 2,
	EventTransportation = 3,
	RequestRides = 4,
}

export const BUSINESS_TRAVEL = 'Business Travel';
export const OFFICE_COMMUTE = 'Office Commute';
export const EVENT_TRANSPORTATION = 'Event Transportation';
export const REQUEST_RIDES = 'Request Rides';

export const RIDE_PURPOSE = [
	{ label: BUSINESS_TRAVEL, value: BUSINESS_TRAVEL, purposeId: RidePurpose.BusinessTravel },
	{ label: OFFICE_COMMUTE, value: OFFICE_COMMUTE, purposeId: RidePurpose.OfficeCommute },
	{ label: EVENT_TRANSPORTATION, value: EVENT_TRANSPORTATION, purposeId: RidePurpose.EventTransportation },
	{ label: REQUEST_RIDES, value: REQUEST_RIDES, id: RidePurpose.RequestRides },
];

export interface ProgramRidePurpose {
	Id: number;
	ProgramId: number;
	Purpose: RidePurpose;
}

export interface OnboardingProgramDto {
	Id?: number;
	RidePerDay?: string;
	Purposes?: ProgramRidePurpose[];
	EstimatedBudget: string;
	EstimatedFrequency: string;
}
// We will use them as concatenated string, e.g.: "AccountVerified, BillingInformation, InviteEmployees"
export enum OnboardingStep {
	//Initial = 0,
	AccountVerified = 1,
	ChooseProgram = 2,
	BillingPreferences = 3,
	BillingInformation = 4,
	InviteEmployees = 5,
	// Last step, employees invitation is done
	//Finished = 5
	Finished = 6,
}
export function stepCompleted(completedSteps: string, step: OnboardingStep): boolean {
	const steps = completedSteps.split(",").map(i => i.trim());
	const stepName = OnboardingStep[step];
	return steps.some(i => i === stepName);
}

export interface UpdateOnboardingStepRequest {
	Step: string;
}
export interface GetOnboardingStepsResponse {
	Steps: string;
}
